import axiosInstance from '@/services/axios'

const searchIngredient = (instId, params) =>
	axiosInstance.get(`/institute/${instId}/inventory/ingredient/search`, {
		params: params,
	})

export { searchIngredient }
